import ProductPageLayout, { ProductPageConfig } from "@/components/products/ProductPageLayout";
import couvertsImage from "@/assets/products/couverts.png";
import couvertsFourchette from "@/assets/products/couverts-fourchette.png";
import couvertsGrandeCuillere from "@/assets/products/couverts-grande-cuillere.png";
import couvertsPetiteCuillere from "@/assets/products/couverts-petite-cuillere.png";

const config: ProductPageConfig = {
  name: "Couverts jetables",
  breadcrumbName: "Couverts",
  subtitle: "Fourchettes, couteaux et cuillères en plastique ou amidon de maïs",
  features: ["Contact alimentaire", "Disponible en plastique", "Disponible en amidon de maïs", "Disponible en stock"],
  variants: [
    { name: "Fourchette standard", material: "Plastique / Amidon de maïs", packaging: "Carton de 1 000 (10 x 100)", palette: "117 cartons", image: couvertsFourchette },
    { name: "Grande cuillère", material: "Plastique / Amidon de maïs", packaging: "Carton de 1 000 (10 x 100)", palette: "72 cartons", image: couvertsGrandeCuillere },
    { name: "Petite cuillère", material: "Plastique / Amidon de maïs", packaging: "Carton de 1 000 (10 x 100)", palette: "108 cartons", image: couvertsPetiteCuillere },
  ],
};

const Couverts = () => <ProductPageLayout config={config} />;
export default Couverts;
